import { Component, OnInit } from '@angular/core';
import { PackageService } from '@services/packages/package.service';
import { ActivatedRoute } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { FrontProfilesService } from '@services/front-profiles/front-profiles.service';
import { Services } from '@ibexfusion/core-utils';
import { ChatsService } from '@services/chats/chats.service';
import { DialogService } from '@services/dialog/dialog.service';
import { AddItemsFromList } from '../../user-admin/user-admin-edit/dialogs/add-items-from-list/add-items-from-list.component';
import { GroupHasRoleInOrganisationService } from '@services/groups/group-has-role-in-organisation.service';
import { GroupHasFrontProfileService } from '@services/groups/group-has-frontprofile.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Component({
  selector: 'app-chats',
  templateUrl: './chats-list.component.html',
  styleUrl: './chats-list.component.scss',
  providers: [PackageService, FrontProfilesService, ChatsService, GroupHasRoleInOrganisationService],
  standalone: false
})
export class ChatsListComponent implements OnInit {
  packageId: string;
  package: Models.Package;
  chats: Models.Chat[];
  profiles: Models.FrontProfileModel[];
  ids: string[];
  columns = [{ prop: 'title' }, { prop: 'admins', valueCallback: (row: any) => (row?.admins || '').split(',').filter(Boolean).length }];

  constructor(
    private packageService: PackageService, private activatedRoute: ActivatedRoute, private profileService: FrontProfilesService, private chatService: ChatsService,
    private dialogService: DialogService, private connectionService: GroupHasRoleInOrganisationService, private profileConnectionService: GroupHasFrontProfileService,
    private dialog: MatDialog, private snackbar: SnackbarService
  ) {
  }

  async ngOnInit() {
    this.packageId = this.activatedRoute.snapshot.params['id'];
    this.package = await this.packageService.get(this.packageId);
    this.profiles = (await this.profileService.find(0, 10000, { packageId: this.packageId, isAnonymous: 0 })).data;
    this.ids = (this.profiles || []).map(a => Services.HashIdService.unhashSingle(a.FrontProfileID));
    this.chats = await this.getChats(this.ids);
    this.chats.forEach(c => {
      c.admins = c.admins.split(',').filter(id => this.profiles.find(p => p.FrontProfileID === Services.HashIdService.unhashSingle(id))).join(',')
    })
  }

  async getChats(ids: string[], batchSize: number = 50) {
    let chats: any = [];
    for (let i = 0; i < ids.length; i += batchSize) {
      const batchIds = ids.slice(i, i + batchSize);
      const query = { $or: batchIds.map(id => ({ chatPartners: { $like: `%${id}` } })) };

      let skip = 0;
      let total = 0;
      let batchResults: any;
      do {
        batchResults = await this.chatService.find(skip, 100, query);
        if (!batchResults || !batchResults.data) {
          break;
        }
        chats.push(...batchResults.data);
        total = batchResults.total || 0;
        skip += batchResults.data.length;
      } while (skip < total && batchResults.data.length > 0);
    }
    chats = chats.filter(c => !(c.title.includes('<->') && c.chatPartners.split(',').filter(Boolean).length === 2));
    return chats;
  }

  async deleteGroup(event: any) {
    const confirmation = await this.dialogService.confirm(`Chatgruppe ${event?.row?.title} wirklich löschen?`);
    if (!confirmation) {
      return;
    }
    await this.chatService.remove(event.row.ChatID);
    this.chats = await this.getChats(this.ids);
  }

  async addAdmin(event: any) {
    const groups = await this.connectionService.find(0, 1000, { roleName: 'chatModuleGroupAdmin', OrganisationID: this.package.OwnerOrganisationID });
    const groupIds = (groups?.data || []).map(g => g.GroupID);
    let profiles: any[] = (await this.profileConnectionService.find(0, 1000, { GroupID: { $in: groupIds } })).data;
    profiles = this.profiles.filter(p => profiles.find(profile => p.FrontProfileID.toString() === profile.ProfileID.toString())).filter(p => !(event?.row?.admins || '').split(',').includes(Services.HashIdService.unhashSingle(p.FrontProfileID)));
    const dialogRef = this.dialog.open(AddItemsFromList, {
      width: '1200px', maxHeight: '90vh',
      data: { availableItems: profiles, columns: [{prop: 'lastName'}, {prop: 'firstName'}, {prop: 'email'}, {prop: 'mobile'}], idField: 'FrontProfileID' }
    });
    const result = await dialogRef.afterClosed().toPromise();
    const admins = (event?.row?.admins || '').split(',').concat((result?.additionalItems || []).map(r => Services.HashIdService.unhashSingle(r))).filter(Boolean).join(',');
    let chatPartners = event.row.chatPartners.split(',').filter(Boolean).join(',');
    admins.split(',').forEach(a => chatPartners += !chatPartners.split(',').includes(a) ? `,${a}` : '');
    if (admins !== event?.row?.admins) {
      await this.chatService.patch(event.row.ChatID, { admins, chatPartners });
      this.chats = await this.getChats(this.ids);
      this.snackbar.success('Benutzer wurden als Admins hinztugefügt');
    }
  }
}
